import CircleLegend from './Circle'

export { CircleLegend }
export default CircleLegend
